export default __webpack_public_path__ + "static/media/background.c4e52aa5.jpeg";